import { AlertTriangle, Trash2, X } from "lucide-react";

export default function ConfirmDeleteModal({
  open,
  title = "Konfirmasi Hapus",
  message = "Data yang dihapus tidak dapat dikembalikan.",
  itemName = "",
  confirmText = "Hapus",
  cancelText = "Batal",
  busy = false,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/65 backdrop-blur-sm"
        onClick={busy ? undefined : onCancel}
      />

      <div className="relative w-full max-w-sm rounded-3xl border border-border bg-card p-5 shadow-2xl">
        <button
          type="button"
          onClick={onCancel}
          disabled={busy}
          className="absolute right-4 top-4 grid h-9 w-9 place-items-center rounded-full bg-muted text-muted-foreground disabled:opacity-50"
          aria-label="Tutup"
        >
          <X size={17} />
        </button>

        <div className="grid h-12 w-12 place-items-center rounded-2xl bg-destructive/15 text-destructive">
          <AlertTriangle size={22} />
        </div>

        <h2 className="mt-4 font-heading text-xl font-extrabold text-card-foreground">
          {title}
        </h2>

        <p className="mt-1 text-sm leading-relaxed text-muted-foreground">
          {message}
        </p>

        {itemName && (
          <div className="mt-3 rounded-2xl border border-border bg-muted px-3 py-2.5 text-sm font-bold text-card-foreground">
            {itemName}
          </div>
        )}

        <div className="mt-5 grid grid-cols-2 gap-2">
          <button
            type="button"
            disabled={busy}
            onClick={onCancel}
            className="rounded-xl bg-muted px-4 py-3 text-sm font-bold text-card-foreground transition active:scale-[0.98] disabled:opacity-50"
          >
            {cancelText}
          </button>

          <button
            type="button"
            disabled={busy}
            onClick={onConfirm}
            className="flex items-center justify-center gap-2 rounded-xl bg-destructive px-4 py-3 text-sm font-bold text-destructive-foreground transition active:scale-[0.98] disabled:opacity-60"
          >
            <Trash2 size={15} />
            {busy ? "Menghapus..." : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
